import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {profileComparisonSectionCardSx} from './profileComparisonSectionStyles';
import {profileComparisonSelection} from '../../../../../layouts/theme/designSystem';
import type {ProfileComparisonDevelopmentEffortItem} from '../../types/ProfileComparisonTypes';

export type ProfileComparisonEffortSlot = 'a' | 'b';

export interface Props {
  slot: ProfileComparisonEffortSlot;
  effort: ProfileComparisonDevelopmentEffortItem;
}

const slotColors = {
  a: profileComparisonSelection.slotA,
  b: profileComparisonSelection.slotB,
} as const;

const effortLevelKeys = {
  low: 'effortLow',
  moderate: 'effortModerate',
  high: 'effortHigh',
} as const;

export const ProfileComparisonDevelopmentEffortTile = ({slot, effort}: Props) => {
  const {t} = useTranslation('translation', {
    keyPrefix: 'workforceDepartmentHealthPage.profileComparison.result',
  });

  const colors = slotColors[slot];
  const slotLabel = slot === 'a' ? t('profileALabel') : t('profileBLabel');
  const effortKey = effortLevelKeys[effort.effortLevel];

  return (
    <Box
      data-testid={`profile-comparison-effort-tile-${slot}`}
      sx={{
        ...profileComparisonSectionCardSx,
        borderColor: colors.borderColor,
        bgcolor: colors.bgcolor,
        mb: 0,
      }}
    >
      <Typography
        sx={{
          fontSize: '10px',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          color: colors.color,
          mb: 0.75,
        }}
      >
        {slotLabel}
      </Typography>
      <Typography sx={{fontSize: '22px', fontWeight: 600, letterSpacing: '-0.5px', mb: 0.5}}>
        {t('gapCount', {count: effort.gapCount})}
      </Typography>
      <Typography sx={{fontSize: '12px', lineHeight: 1.5, color: 'text.secondary'}}>{t(effortKey)}</Typography>
    </Box>
  );
};
